module.exports = __webpack_public_path__ + "assets/images/arrow_down.25233d75176d296dd11ead36cc1f8996.svg";